<!--在线监管-监管地图-->
<template>
  <section>
    <el-form :inline="true" size="mini">
      <el-form-item>
        <el-cascader
            style="width: 300px"
            placeholder="所属单位"
            v-model="selOwner"
            :options="customerTree"
            :props="orgProps"
            clearable
            filterable
            @change="getData"
        />
      </el-form-item>
      <el-form-item>
        <el-cascader
            placeholder="区域"
            v-model="selArea"
            :options="areaTree"
            :props="areaProps"
            clearable
            filterable
            @change="getData"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
      </el-form-item>
      <el-form-item>
        <div class="quick_jump_box">
          <router-link v-for="(item, index) in quickJumpMenus" :key="index" :to="item.page">
            <i class="el-icon-message" :style="{
                color: item.color
              }"></i>
            <span>{{ item.text }}</span>
          </router-link>
        </div>
      </el-form-item>
    </el-form>
    <div v-loading="mapLoading">
      <table class="device-info">
        <thead>
        <tr>
          <th rowspan="2">监测点 {{ LocaleNum }}</th>
          <th rowspan="2">监测设备 {{ LocaleNum }}</th>
          <th>昨日在线 {{ daily.Dnormal }}</th>
          <th>昨日离线 {{ LocaleNum - daily.Dnormal }}</th>
          <th>昨日超标 {{ daily.Dexcess }}</th>
          <th rowspan="2">昨日PM2.5减排量 {{ daily.Pm25 }}KG</th>
          <th rowspan="2">昨日PM10减排量 {{ daily.Pm10 }}KG</th>
          <th rowspan="2">昨日油烟减排量 {{ daily.RedEmissions }}KG</th>
          <th rowspan="2">昨日VOCS减排量 {{ daily.RedVocs }}KG</th>
        </tr>
        <tr>
          <th>占比 {{ Dtotal === 0 ? 0 : ((daily.Dnormal) / LocaleNum * 100).toFixed(2) + '%' }}</th>
          <th>占比 {{ Dtotal === 0 ? 0 : ((LocaleNum - daily.Dnormal) / LocaleNum * 100).toFixed(2) + '%' }}
          </th>
          <th>占比 {{ Dtotal === 0 ? 0 : (daily.Dexcess / LocaleNum * 100).toFixed(2) + '%' }}</th>
        </tr>
        </thead>
      </table>

      <div class="echarts" id="chartMap" ref="chartMap"></div>

      <el-dialog :visible.sync="showDlg" @close="handlerClose" width="85%" top="20px" :style="{ marginTop: showTyp ? '10px' : '' }">
        <!-- <figure style="background-color: rgb(175, 173, 173)"></figure> -->
        <el-form :inline="true" size="mini" v-if="device.i === 0">
          <!-- <el-form-item>
            <el-select v-model="concentrationType" placeholder="请选择">
              <el-option :value="1" label="按十分钟"></el-option>
              <el-option :value="2" label="按天"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <!-- 按十分钟 -->
            <el-date-picker
                v-if="concentrationType === 1"
                @change="handleDateSel"
                v-model="selDate"
                type="date"
                value-format="timestamp"
                placeholder="日期选择"
            />

            <!-- 按天 -->
            <el-date-picker
                v-else-if="concentrationType === 2"
                type="daterange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-download" @click="handleExport">导出</el-button>
          </el-form-item>
        </el-form>
        <template v-if="showTyp">
          <template v-if="device.i === 0">
            <span slot="title">
              <strong>浓度曲线</strong>
            </span>
            <div class="chart-line">
              <chart :options="tenMinOption" autoresize/>
            </div>
          </template>
          <template v-else>
            <span slot="title">
              <strong>油烟减排</strong>
            </span>
            <div class="chart-line">
              <chart :options="reduceOption" autoresize/>
            </div>
          </template>
        </template>
        <template v-else>
          <span slot="title">
            <strong>每分钟采集数据</strong>
          </span>
          <el-table
              :data="intimeData.content"
              size="mini"
              border
              highlight-current-row
              v-loading="loading"
              :max-height="clientHeight"
              style="width: 100%"
          >
            <el-table-column type="index" label="序号" align="center" width="55"/>
            <el-table-column
                prop="acquit_at"
                :formatter="dateFormat"
                label="采集时间"
                width="142"
                align="center"
                header-align="center"
            />
            <el-table-column
              label="风机状态"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                <span>{{ FanFilterStatusFormatter(scope.row.fan_status) }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="净化器状态"
              align="center"
              header-align="center"
            >
              <template slot-scope="scope">
                <span>{{ FanFilterStatusFormatter(scope.row.filter_status) }}</span>
              </template>
            </el-table-column>
<!--            <el-table-column-->
<!--                :formatter="fanFilterFormatter()"-->
<!--                label="风机状态"-->
<!--                align="center"-->
<!--                header-align="center"-->
<!--            />-->
<!--            <el-table-column-->
<!--                :formatter="fanFilterFormatter()"-->
<!--                label="净化器状态"-->
<!--                align="center"-->
<!--                header-align="center"-->
<!--            />-->
            <template v-if="device.Typ === 2">
              <el-table-column
                  prop="emissions_conc"
                  label="油烟浓度(mg/m³)"
                  align="center"
                  header-align="center"
              />
              <el-table-column
                  prop="granule_conc"
                  label="颗粒物浓度(mg/m³)"
                  align="center"
                  header-align="center"
              />
              <el-table-column
                  prop="hydrocarbon_conc"
                  label="非甲烷总烃浓度(mg/m³)"
                  align="center"
                  header-align="center"
              />
              <!--
              <el-table-column prop='velocity' label='流速' align='center' header-align='center' />
              <el-table-column prop='temperature' label='温度' align='center' header-align='center' />
              <el-table-column prop='moisture' label='湿度' align='center' header-align='center' />-->
            </template>
            <template v-else>
              <el-table-column prop="poweroff" label="电源关闭指令" align="center" header-align="center"/>
              <!-- <el-table-column prop='Flag' label='设备状态' align='center' header-align='center' /> -->
            </template>
          </el-table>
          <el-pagination
              small
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="filter.page"
              :page-sizes="filter.pageSizes"
              layout="total, sizes, prev, pager, next, jumper"
              :total="intimeData.total"
              style="display:inline-block;margin-left:15px"
          />
        </template>
      </el-dialog>
    </div>
    <el-dialog
        :visible.sync="isShowNotificationDialog"
        style="position: fixed !important;
        top: 50%;
        left: 50%;
        width: 120%;
        height: 120%;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transform: translate(-50%, -50%) !important;
        z-index: 9999 !important;"
    >
<!--一点一档的组件-->
      <div style="max-height: calc(100vh - 150px); overflow-y: auto; display: flex; flex-direction: column;margin-top: -30px">
        <point-info-dialog
            :device="device"
        ></point-info-dialog>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import {mapState} from 'vuex'
import {
  ifNull,
  dateFormater,
  loadData,
  export_json,
  join,
  getUserInfo,
  getSinglePname,
  ownerJoin
} from '@/util/index'

import greenCircle from '@/asset/img/mapOnline.png'
import greyCircle from '@/asset/img/mapOffline.png'
import redCircle from '@/asset/img/mapAlert.png'
import blackCircle from '@/asset/img/mapClosed.png'
import orangeCircle from '@/asset/img/mapPreAlert.png'


import DashboardMarker from '@/component/DashboardOverlay'

import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/markLine'
import 'echarts/lib/component/legend'
import PointInfoDialog from "@/component/PointInfoDialog.vue";
const iconSize = new AMap.Size(32, 32)
const greenCircleIcon = new AMap.Icon({
  size: iconSize,
  image: greenCircle,
  imageSize: iconSize
})

const redCircleIcon = new AMap.Icon({
  size: iconSize,
  image: redCircle,
  imageSize: iconSize
})

const orangeCircleIcon = new AMap.Icon({
  size: iconSize,
  image: orangeCircle,
  imageSize: iconSize,
})

const greyCircleIcon = new AMap.Icon({
  size: iconSize,
  image: greyCircle,
  imageSize: iconSize,
})

const blackCircleIcon = new AMap.Icon({
  size: iconSize,
  image: blackCircle,
  imageSize: iconSize,
})



const infoWindow = new AMap.InfoWindow({
  isCustom: true,
  content: null,
  anchor: 'top-left',
  offset: new AMap.Pixel(16, -45),
  closeWhenClickMap: true
})
export default {
  components: {
    PointInfoDialog,
    chart: ECharts,
    DashboardMarker
  },
  data() {
    return {
      aliMap: null,
      dotColor: ['#FF001A', '#78ff79', '#FEFF65', '#AEAEAE', '#000000'], //红 绿色 黄色 灰色 黑色
      concentrationType: 1, // 浓度类型：1按十分钟；2 按天
      pickerOptions: {
        // 查看浓度：按天
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      quickJumpMenus: [
        {
          type: 1,
          color: 'red',
          text: '超标报警',
          page: '/AlarmMessage?type=ExceedStandard'
        },
        {
          type: 2,
          color: 'yellow',
          text: '异常离线',
          page: '/AlarmMessage?type=AbnormalOffline'
        }
      ],
      selDate: null,
      selOwner: null,
      selArea: null,
      data: [],
      now: null,
      Mtotal: 0,
      Dtotal: 0,
      LocaleNum: null,
      param: {

      },
      userInfo: null,
      loading: true,
      mapLoading: false,
      daily: {},
      mapCenter: {lng: 120.306305, lat: 30.424877},
      mapZoom: 14,
      showDlg: false,
      device: {},
      showTyp: null,
      exportData: null,
      linkStatus: null,
      intimeData: {},
      EmissionsSill: null,
      GranuleSill: null,
      HydrocarbonSill: null,
      isShowNotificationDialog: false,
      reduceOption: {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['油烟减排量', 'pm25减排量', 'pm10减排量', '非甲烷减排量']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [],
          boundaryGap: true,
          axisLabel: {
            interval: 17
          }
        },
        yAxis: {
          type: 'value',
          name: '减排量/克'
        },
        series: [
          {
            name: '油烟减排量',
            type: 'line',
            data: [],
            itemStyle: {
              normal: {
                color: '#00A1FF',
                lineStyle: {
                  type: 'solid',
                  color: '#00A1FF'
                }
              }
            },
            markLine: {
              symbol: 'none',
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'solid',
                    color: '#00A1FF'
                  },
                  label: {
                    position: 'start',
                    formatter: '{c} '
                  }
                }
              },
              data: [
                {
                  name: '阈值',
                  yAxis: 1
                }
              ]
            }
          },
          {
            name: 'pm25减排量',
            type: 'line',
            data: [],
            itemStyle: {
              normal: {
                color: '#F5B049',
                lineStyle: {
                  type: 'solid',
                  color: '#F5B049'
                }
              }
            },
            markLine: {
              symbol: 'none',
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'solid',
                    color: '#F5B049'
                  },
                  label: {
                    position: 'start',
                    formatter: '{c} '
                  }
                }
              },
              data: [
                {
                  name: '阈值',
                  yAxis: 1
                }
              ]
            }
          },
          {
            name: 'pm10减排量',
            type: 'line',
            data: [],
            itemStyle: {
              normal: {
                color: '#009999',
                lineStyle: {
                  type: 'solid',
                  color: '#009999'
                }
              }
            },
            markLine: {
              symbol: 'none',
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'solid',
                    color: '#009999'
                  },
                  label: {
                    position: 'start',
                    formatter: '{c} '
                  }
                }
              },
              data: [
                {
                  name: '阈值',
                  yAxis: 1
                }
              ]
            }
          },
          {
            name: '非甲烷减排量',
            type: 'line',
            data: [],
            itemStyle: {
              normal: {
                color: '#990000',
                lineStyle: {
                  type: 'solid',
                  color: '#990000'
                }
              }
            },
            markLine: {
              symbol: 'none',
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'solid',
                    color: '#990000'
                  },
                  label: {
                    position: 'start',
                    formatter: '{c} '
                  }
                }
              },
              data: [
                {
                  name: '阈值',
                  yAxis: 1
                }
              ]
            }
          }
        ]
      },
      tenMinOption: {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['油烟浓度', '颗粒物浓度', '非甲烷总烃浓度']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [],
          boundaryGap: false,
          axisLabel: {
            interval: 17
          }
        },
        yAxis: {
          type: 'value',
          // min: 5,
          // data : [0, 0.5, 1, 1.5, 2, 2.5, 3, 3.5, 4, 4,5],
          name: '平均浓度mg/m³'
        },
        series: [
          {
            name: '油烟浓度',
            type: 'line',
            data: [],
            itemStyle: {
              normal: {
                color: '#00A1FF',
                lineStyle: {
                  type: 'solid',
                  color: '#00A1FF'
                }
              }
            },
            markLine: {
              symbol: 'none',
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'solid',
                    color: '#00A1FF'
                  },
                  label: {
                    position: 'start',
                    formatter: '{c} '
                  }
                }
              },
              data: [
                {
                  name: '阈值',
                  yAxis: 1
                }
              ]
            }
          },
          {
            name: '颗粒物浓度',
            type: 'line',
            data: [],
            itemStyle: {
              normal: {
                color: '#F5B049',
                lineStyle: {
                  type: 'solid',
                  color: '#F5B049'
                }
              }
            },
            markLine: {
              symbol: 'none',
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'solid',
                    color: '#F5B049'
                  },
                  label: {
                    position: 'start',
                    formatter: '{c} '
                  }
                }
              },
              data: [
                {
                  name: '阈值',
                  yAxis: 1
                }
              ]
            }
          },
          {
            name: '非甲烷总烃浓度',
            type: 'line',
            data: [],
            itemStyle: {
              normal: {
                color: '#009999',
                lineStyle: {
                  type: 'solid',
                  color: '#009999'
                }
              }
            },
            markLine: {
              symbol: 'none',
              itemStyle: {
                normal: {
                  lineStyle: {
                    type: 'solid',
                    color: '#009999'
                  },
                  label: {
                    position: 'start',
                    formatter: '{c} '
                  }
                }
              },
              data: [
                {
                  name: '阈值',
                  yAxis: 1
                }
              ]
            }
          }
        ]
      },
      filter: {
        page: 1,
        size: 20,
        pageSizes: [20, 30, 50]
      }
    }
  },
  computed: {
    ...mapState(['areaTree', 'customerTree', 'clientHeight', 'locale']),
    ...mapState({
      orgProps: (state) =>
          Object.assign({}, state.props, {label: 'Org', checkStrictly: true}),
      areaProps: (state) =>
          Object.assign({}, state.props, {checkStrictly: true})
    })
  },
  created() {
    window.handleShowIntime = (mn) => {
      this.filter.page = 1//每次打开每分钟采集数据页码置1
      this.device = {MN: mn, Typ: 2}
      this.showTyp = false
      this.showDlg = true
      this.getIntimeData()
    },

    window.handlePdfRecord = (e) => {
      const par = {locale_id: e}
      this.$get('admin/locale/info', par)
      .then((res) => {
        this.device = res.locale
        this.isShowNotificationDialog = true
      })
      .catch(() => {
      })
    }

    window.handleShowTenMin = (e) => {
      var data = e.split("_")
      this.device = {MN: data[0], Typ: parseInt(data[1]),i:parseInt(data[3]),  LocaleId: data[2]}
      this.showTyp = true
      this.showDlg = true
      if (data[3] === "0") {
        this.getTenMinData()
      } else {
        this.getLast30Data(data[2])
      }
    }
  },
  mounted() {
    this.aliMap = new AMap.Map('chartMap', {
      resizeEnable: true,
      mapStyle: 'amap://styles/181dc194075339e4e2ca424d04024247',
      zoom: 13
    })
    this.now = Date.parse(new Date()) / 1000
    const user = getUserInfo()
    this.userInfo = user.Info
    this.getData()

  },
  methods: {
    async getData() {
      this.mapLoading = true
      let param = {
        StartAt: 0,
        Size: 1200,   //限制查找1500个点
        Param: {}
      }
      let param1 = {
        StartAt: 0,
        Size: 1200,   //限制查找1500个点
        Param: {
          "StatusOfRecord":"NORMAL",
          "Typ":2
        }
      }
      // 所属单位搜索
      if (this.selOwner) {
        param.Param.Owner = `${ownerJoin(this.selOwner, this.userInfo)}`
        param1.Param.Owner = `${ownerJoin(this.selOwner, this.userInfo)}`
        //修改用户清空Owner查询不到数据的问题
        if(this.selOwner.length === 0) {
          delete param.Param.Owner;
          delete param1.Param.Owner;
        }
      }
      //区域信息搜索
      if (this.selArea) {
        param.Param.Area = ""
        for (const areaElement of this.selArea) {
          param.Param.Area = param.Param.Area + '/' + areaElement
        }
        param1.Param.AreaId = ""
        for (const areaElement1 of this.selArea) {
          param1.Param.AreaId = param1.Param.AreaId + '/' + areaElement1
        }
      }
      this.Mtotal = 0
      this.Dtotal = 0
      await this.$post('admin/listMapDevice', param).then((res) => {
        this.daily = res.Daily
        this.data = []
        this.LocaleNum = res.LocaleNum
        this.getMapPoint(param1)
      })

    },
    dotColorStatusExeFormatter(Status) {
      var r = 3
      switch (Status) {
        case 'NORMAL':
          r = 1
          break
        case 'EXCESS':
          r = 0
          break
        case 'DOWN':
          r = 3
          break
        case 'OFF':
          r = 4
          break
        case 'ALARM':
          r = 2
          break
      }
      return r
    },
    dotColorFormatter(Status) {
      var r = blackCircleIcon
      switch (Status) {
        case 'NORMAL':
          r = greenCircleIcon
          break
        case 'EXCESS':
          r = redCircleIcon
          break
        case 'DOWN':
          r = greyCircleIcon
          break
        case 'OFF':
          r = blackCircleIcon
          break
        case 'ALARM':
          r = orangeCircleIcon
          break
      }
      return r
    },
    dotColorAndStatusFormatter(Status) {
      let r = []
      switch (Status) {
        case 'NORMAL':
          r = [1, '达标']
          break
        case 'EXCESS':
          r = [1, '超标']
          break
        case 'DOWN':
          r = [3, '离线']
          break
        case 'OFF':
          r = [4, '异常离线']
          break
        case 'ALARM':
          r = [1, '预警']
          break
        default:
          r = [4, '未知状态']
      }
      return r
    },
    async getMapPoint(param1){
      if (this.aliMap) {
        this.aliMap.clearMap(); // 清除地图上所有的覆盖物
      }
      var that = this
      if (param1.Param.AreaId === "") {
        delete param1.Param.AreaId;
      }
      await this.$post('admin/listDataIntime', param1).then((res) => {
        if (res.content.length > 0) {
          that.aliMap.setCenter([res.content[0].LocaleLng, res.content[0].LocaleLat])
        }
        for (var i = 0; i < res.content.length; i++) {
          if (res.content[i].Typ === 1) {
            this.Mtotal += 1
          } else {
            this.Dtotal += 1
          }
          if (i < 1200) {
            var item = res.content[i]
            var healthStatusColor = that.dotColor[this.dotColorStatusExeFormatter(item.Status)]
            var healthColor = item.HealthCodeColor === 'Green' ? '#78ff79' : (item.HealthCodeColor === 'Red' ? '#c70b0b' : '#FEFF65')
            var r = that.dotColorAndStatusFormatter(item.Status)
            var intimeColor = that.dotColor[r[0]]
            var content = `
            <div style="border:1px solid #03608C;padding:8px 16px;background-color:#012954;opacity:0.8;font-size: 14px;min-width: 200px;max-width:300px;">
              <p>
              <span style="color:#c7c7cc">店铺名称：</span>
              <span style="color:#c7c7cc">${item.Locale}</span>
              </p>
              <p>
                <div style="display:inline-block;color:#c7c7cc">实时状态：</div>
                <div style="width:10px;height:10px;background-color:${intimeColor};display:inline-block;border-radius:50%;margin-right:5px"></div>
                <span style="color:#c7c7cc">(${r[1]})</span>
                <div style="display:inline-block;color:#c7c7cc">排放状态码：</div>
                <div style="width:10px;height:10px;background-color:${healthStatusColor};display:inline-block;border-radius:50%;margin-right:5px"></div>
              </p>
              <p>
                <div style="display:inline-block;color:#c7c7cc">红绿码状态：</div>
                <div style="width:10px;height:10px;background-color:${healthColor};display:inline-block;border-radius:50%;margin-right:5px"></div>
              </p>
              <p>
                <span style="color:#c7c7cc;">联系人：</span>
                <span style="color:#c7c7cc;">${item.CustomerName}</span>
              </p>
              <p>
                <span style="margin-left:4px;color:#c7c7cc">联系电话：</span>
                <span style="color:#c7c7cc">${item.CustomerMobile}</span>
              </p>
              <h5 style="color:#c7c7cc;font-size:14px;margin:5px 0 0;">监测点信息</h5>
              <p>
                <span style="color:#c7c7cc">监测点名称：</span>
                <span style="color:#c7c7cc">${item.Locale}</span>
              </p>
              <p>
                <span style="color:#c7c7cc">所属单位：</span>
                <span style="color:#c7c7cc">${item.OwnerName}</span>
              </p>
              <p>
                <span style="color:#c7c7cc">地址：</span>
                <span style="color:#c7c7cc">${item.Addr}</span>
              </p>
              <p>
                <span style="color:#c7c7cc">设备：</span>
                <span style="color:#c7c7cc">${item.Id}</span>
              </p>
              <div style="display:flex;flex-wrap:wrap;gap:5px;margin-top:10px;">
    <button onclick="handlePdfRecord('${item.Lid}')" style="background-color:#409EFF;color:white;border:none;padding:4px 8px;border-radius:3px;font-size:12px;cursor:pointer;">一点一档</button>
    <button onclick="handleShowIntime('${item.Id}')" style="background-color:#67C23A;color:white;border:none;padding:4px 8px;border-radius:3px;font-size:12px;cursor:pointer;">1分钟数据</button>
    <button onclick="handleShowTenMin('${item.Id + "_" + item.Typ.toString() + "_" + item.Lid + "_0"}')" style="background-color:#E6A23C;color:white;border:none;padding:4px 8px;border-radius:3px;font-size:12px;cursor:pointer;">浓度曲线</button>
    <button onclick="handleShowTenMin('${item.Id + "_" + item.Typ.toString() + "_" + item.Lid + "_1"}')" style="background-color:#F56C6C;color:white;border:none;padding:4px 8px;border-radius:3px;font-size:12px;cursor:pointer;">油烟减排</button>
  </div>
            </div>
          `
            const marker = new AMap.Marker({
              position: [item.LocaleLng, item.LocaleLat],
              zIndex: 1,
              anchor:'center',//设置地图标记的锚点位置
              offset: new AMap.Pixel(0, 0),//设置图标的偏移量，加入上面这两个即可解决地图缩放标记点放大缩小偏移问题
              icon: this.dotColorFormatter(item.Status),
              extData: {
                Status: item.Status,
                HealthCodeColor: item.HealthCodeColor,
                Mn: item.Id,
                Content: content
              }
            })
            marker.on('click', function (content) {
              return function () {
                infoWindow.setContent(content)
                infoWindow.open(that.aliMap, marker.getPosition())
              }
            }(content))
            marker.setMap(that.aliMap)
          }
        }
        this.mapLoading = false
      })
    },

    getSinglePname(pid) {
      return getSinglePname(this.customerTree, pid, 'Org')
    },
    dateFormat(r, c) {
      return dateFormater(r[c.property], true)
    },
    /**
     * @return {string}
     */
    FanFilterStatusFormatter(row) {
      switch (row) {
        case '0':
          return '关'
        case '1':
          return '开'
        case '3':
          return '异常'
        case '4':
          return '失效'
        case '5':
          return '闲置'
        case '-1':
          return '未选择'
        default:
          return '未连接'
      }
    },
    fanFilterFormatter(r) {
      if (this.linkStatus === 1) {
        return '开'
      }
      return '-'
    },
    handleExport() {
      if (this.showTyp) {
        export_json(
            dateFormater(this.selDate / 1000, false) + '-' + this.mn,
            this.exportData,
            {
              采集时间: '采集时间',
              油烟平均浓度: '油烟平均浓度',
              颗粒物平均浓度: '颗粒物平均浓度',
              非甲烷总烃平均浓度: '非甲烷总烃平均浓度'
            }
        )
      } else {
        this.$download('admin/exportIntimeData', {
          mn: this.device.MN,
          typ: this.device.Typ,
          at: this.selDate / 1000
        })
      }
    },
    handleDateSel(v) {
      if (v !== null) {
        if (this.showTyp) {
          this.getTenMinData()
        } else {
          this.getIntimeData()
        }
      }
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    // 改变页容量
    handleSizeChange(size) {
      this.filter.size = size
      this.getIntimeData()
    },
    // 翻页
    handleCurrentChange(page) {
      this.filter.page = page
      this.getIntimeData()
    },
    getIntimeData() {
      this.loading = true
      this.$post('admin/listIntimeData', {
        StartAt: (this.filter.page - 1) * this.filter.size,
        Size: this.filter.size,
        mn: this.device.MN,
        typ: this.device.Typ,
        at: this.selDate / 1000
      }).then((res) => {
        this.loading = false
        this.intimeData = res
        if (res.total !== 0 && this.selDate === null) {
          this.selDate = new Date(
              new Date(res.content[0]['acquit_at'] * 1000).setHours(0, 0, 0, 0)
          ).getTime()
        }
      })
    },
    getTenMinData() {
      this.loading = true

      var params = {localeId: this.device.LocaleId,at: this.selDate / 1000}
      this.$post("admin/listTenMinData", params).then((res) => {
        this.loading = false
        this.exportData = []
        this.tenMinOption.series[0]['data'] = []
        this.tenMinOption.series[0]['markLine']['data'][0]['yAxis'] = 2
        this.tenMinOption.xAxis['data'] = []
        this.tenMinOption.series[1]['data'] = []
        this.tenMinOption.series[1]['markLine']['data'][0]['yAxis'] = 5
        this.tenMinOption.series[2]['data'] = []
        this.tenMinOption.series[2]['markLine']['data'][0]['yAxis'] = 10
        if (res && res.length !== 0) {

          if (this.selDate === null) {
            this.selDate = new Date(
              new Date(res[0]['acquit_at'] * 600 * 1000).setHours(0, 0, 0, 0)
            ).getTime()
          }
          let data
          const t = new Date(this.selDate)
          t.setHours(0, 0, 0, 0)
          const endTime = Math.floor(t.getTime() / 600000) + 143
          let at
          for (var i = Math.floor(t.getTime() / 600000); i <= endTime; i++) {
            data = res.find((e) => e.acquit_at === i)

            at = dateFormater(i * 600, true, true)
            if (!data) {
              data = {
                emissions_conc: 0,
                granule_conc: 0,
                hydrocarbon_conc: 0,
                counter: 1
              }
            } else {
              this.exportData.push({
                采集时间: at,
                油烟平均浓度: (data.emissions_conc).toFixed(2),
                颗粒物平均浓度: (data.granule_conc).toFixed(2),
                非甲烷总烃平均浓度: (
                  data.hydrocarbon_conc
                ).toFixed(2)
              })
            }
            this.tenMinOption.series[0]['data'].push(
              (data.emissions_conc).toFixed(2)
            )
            this.tenMinOption.series[1]['data'].push(
              (data.granule_conc).toFixed(2)
            )
            this.tenMinOption.series[2]['data'].push(
              (data.hydrocarbon_conc).toFixed(2)
            )
            this.tenMinOption.xAxis['data'].push(at)
          }
        }
        this.$forceUpdate()
      })
    },
    getLast30Data(localeId) {
      this.loading = true
      let now = new Date()
      now.setDate(now.getDate());
      now.setHours(0, 0, 0, 0);
      let end = now.getTime();
      now.setDate(now.getDate() - 15);
      let begin = now.getTime();
      const param = {
        locale_id: localeId,
        start_at: parseInt(begin / 1000),
        end_at: parseInt(end / 1000) + 86399
      }
      this.$get("admin/locale_reduce_between_data", param).then(res => {
        this.loading = false
        this.exportData = []
        this.reduceOption.series[0]['data'] = []
        this.reduceOption.series[0]['type'] = 'bar'
        this.reduceOption.xAxis['data'] = []
        this.reduceOption.xAxis['axisLabel']['interval'] = 1
        this.reduceOption.series[1]['data'] = []
        this.reduceOption.series[1]['type'] = 'bar'
        this.reduceOption.series[2]['data'] = []
        this.reduceOption.series[2]['type'] = 'bar'
        this.reduceOption.series[3]['data'] = []
        this.reduceOption.series[3]['type'] = 'bar'
        if (res && res.length !== 0) {
          res = res.content
          for (let i = res.length - 1; i >= 0; i--) {
            this.exportData.push({
              采集时间: res[i].date.substr(5, 5),
              油烟减排量: res[i].emissions.toFixed(2),
              pm25减排量: res[i].pm25.toFixed(2),
              pm10减排量: res[i].pm10.toFixed(2),
              非甲烷减排量: res[i].vocs.toFixed(2),
            })
            this.reduceOption.series[0]['data'].push(
                (res[i].emissions).toFixed(2)
            )
            this.reduceOption.series[1]['data'].push(
                (res[i].pm25).toFixed(2)
            )
            this.reduceOption.series[2]['data'].push(
                (res[i].pm10).toFixed(2)
            )
             this.reduceOption.series[3]['data'].push(
                (res[i].vocs).toFixed(2)
            )
            this.reduceOption.xAxis['data'].push(res[i].date.substr(5, 5))
          }
          this.$forceUpdate()
        }
      })
    },
    handlerClose() {
      this.selDate = null
      // this.getData()
    },

  }
}
</script>
<style lang="scss" scoped>
// 快速跳转 css
.quick_jump_box {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 20px;

  a {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-decoration: none;
    color: #333333;
    font-size: 12px;
    padding: 0 10px;

    i {
      font-size: 18px;
    }

    &:hover {
      color: #409eff;
    }
  }
}


.echarts {
  width: 100%;
  height: 76vh;
  .BMap_bubble_content div {
    padding-top: 8px;
  }
  .bg-purple {
    // padding: 4px;
    // border-radius: 4px;
    font-size: 13px;
    min-width: 320px;
    // background: #E1EDF2;
  }
}

.window_info_box {
  p {
    margin: 0;
    font-size: 12px;
    color: #999999;

    span {
      color: #333333;
    }
  }

  h5 {
    font-size: 12px;
    // margin: 8px 0 5px;
    margin: 5px 0 0;
  }
}

.device-info {
  display: table;
}
</style>
